import type { ComponentProps } from 'react';
import { Avatar } from '@kidova/ui-web';
import { useI18n } from '../i18n';

/** The avatar button that opens the account menu. */
export function AccountButton({ name, ...props }: ComponentProps<'button'> & { name: string }) {
  const { t } = useI18n();
  return (
    <button
      type="button"
      className="rounded-full p-1 hover:bg-[var(--kd-hover-wash)]"
      aria-label={t('shell.account')}
      data-testid="account-menu"
      {...props}
    >
      <Avatar name={name} size="sm" decorative />
    </button>
  );
}
